import React from 'react';
import ProductContainer from '../../containers/productmng/ProductContainer';

const ProductViewPage = () => {
  return <ProductContainer/>;
};

export default ProductViewPage;
